/**
 * External dependencies
 */
import { LitElement, html, css, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import {
	uapRecipeTemplateLibraryConfig
} from '../../utilities';

/**
 * Styles
 */
import styles from './web-component-style.scss?inline';

/**
 * Defines <uap-rtl-results-base-filters> custom element
 * This component is used to display the base filters defined in library.baseFilters
 * and dispatch an event when the filter is changed.
 */
@customElement( 'uap-rtl-results-base-filters' )
class UAPRTL_ResultsBaseFilters extends LitElement {

	// Define style
	static styles = css`${unsafeCSS( styles )}`;

	// Library config.
	library = uapRecipeTemplateLibraryConfig;

	// Filters config.
	baseFilters = null;

	/**
	 * Handle checkbox
	 *
	 * @param {String} name - The filter name
	 * @param {Boolean} checked - The checked value
	 *
	 * @return {void}
	 */
	_handleCheckbox( name, checked ) {
		// Update the base filter active state.
		this.baseFilters[name].active = checked;

		// Dispatch the filter change event.
		this.dispatchEvent( new CustomEvent( 'uap-rtl-base-filter-change', {
			detail: {
				baseFilters : this.baseFilters,
			},
			bubbles: true,
			composed: true
		} ) );
	}

	/**
	 * Render the component
	 *
	 * @return {TemplateResult} The template result
	 */
	render() {

		// Check if the library is available
		const isReady = this.library && this.library.isReady;
		if ( ! isReady ) {
			return html``;
		}

		// Set the base filters ( name and checked value )
		if ( this.baseFilters === null ) {
			this.baseFilters = this.library.baseFilters.reduce( ( acc, filter ) => {
				acc[filter.name] = {
					active: false,
					ids: filter.ids
				};
				return acc;
			}, {} );
		}

		// Render the component
		return html`
			<div class="uap-rtl-checkbox-filters">
				<div class="uap-rtl-checkbox-filters__title">
					${ escapeHTML( __( 'Requirements', 'uncanny-automator' ) ) }
				</div>
				${this.library.baseFilters.map( filter => html`
					<div class="uap-rtl-checkbox-filters__filter">
						<div class="uap-rtl-checkbox-filters__form-checkbox">
							<label>
								<span>${escapeHTML( __( filter.label, 'uncanny-automator' ) )}</span>
								<input 
									type="checkbox" 
									value="${filter.name}"
									?checked=${this.baseFilters[filter.name].active}
									@click=${event => {
										this._handleCheckbox( filter.name, event.target.checked );
									}}
								/>
								<div class="uap-rtl-checkbox-filters__checkbox--show"></div>
							</label>
						</div>
						<div class="uap-rtl-checkbox-filters__filter-description">
							${escapeHTML( __( filter.description, 'uncanny-automator' ) )}
						</div>
					</div>
				` )}
			</div>
		`;
	}
}
